import stateMessages from './messages'


export type StateMessages  = typeof stateMessages
export type StateShortname = keyof StateMessages
export type StatesInObject = { [key in StateShortname]: string | StateMessages[key] }

// Pass on "intl" object if you need string type in title

// return => [ { value: 'AK', title: 'Alaska' / intl message } ]
const getUsaStatesInArray = (intl?: Intl) => (
  Object.keys(stateMessages).map((state: StateShortname) => ({
    value: state,
    title: intl ? intl.formatMessage(stateMessages[state]) : stateMessages[state],
  }))
)

// return => [ { value: 'AK', title: 'AK' } ]
const getShortUsaStatesInArray = () => (
  Object.keys(stateMessages).map((state: StateShortname) => ({
    value: state,
    title: state,
  }))
)

// return => { AK: 'Alaska' / intl message }
const getUsaStatesInObject = (intl?: Intl): StatesInObject => {
  const states: Partial<StatesInObject> = {}

  Object.keys(stateMessages).forEach((state: StateShortname) => {
    states[state] = intl ? intl.formatMessage(stateMessages[state]) : stateMessages[state]
  })

  return states as StatesInObject
}


export {
  getUsaStatesInArray,
  getUsaStatesInObject,
  getShortUsaStatesInArray,
}
